module.exports = __webpack_public_path__ + "img/Internetpublic.02b2a0e8.png";